import React, { useState, useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { styled } from 'styled-components';
import { c } from '@debbie/cortex/dist/index.js';
import { selectCaseUpdates } from '@debbie/cortex/dist/case/selectors.js';
import { selectCaseById } from '@debbie/cortex/dist/cases/selectors.js';
import { selectMe } from '@debbie/cortex/dist/me/selectors.js';
import { PlaceholderLoader } from '../index.js';
import CaseInfo from '../CaseInfo/index.js';
import CasePauseStatus from '../CasePauseStatus/index.js';
import CaseHistory from '../Hist/CaseHistory.js';
import Panel from '../Panel.js';
import Tooltip from '../Tooltip.js';
import deletedImage from '../../assets/images/deleted_image.svg';
const CasePreview = (props) => {
    const me = useSelector(selectMe);
    const lang = useSelector((r) => r.lang);
    const singleCase = useSelector((s) => selectCaseById(s, props.caseId));
    const caseUpdates = useSelector((s) => singleCase && selectCaseUpdates(s, singleCase.caseId));
    const [hovered, setHovered] = useState(false);
    const [isTooltipMounted, setIsTooltipMounted] = useState(false);
    const [showTooltipOnTop, setShowTooltipOnTop] = useState(false);
    const ref = useRef(null);
    const id = props.caseId;
    const onMouseIn = () => {
        setHovered(true);
    };
    const onMouseOut = () => {
        setHovered(false);
    };
    useEffect(() => {
        if (isTooltipMounted) {
            loadCases();
        }
    }, [isTooltipMounted]);
    useEffect(() => {
        if (singleCase && !caseUpdates) {
            c.cases.getUpdates(singleCase.caseId);
        }
    }, [singleCase]);
    const loadCases = () => {
        if (!singleCase) {
            c.cases.getById(props.caseId);
        }
    };
    return (React.createElement("div", { onMouseEnter: onMouseIn, onMouseLeave: onMouseOut, onClick: (e) => {
            e.stopPropagation();
            e.preventDefault();
        }, style: {
            position: 'relative',
            display: 'inline-block',
        } },
        React.createElement(CasePreviewStyled, { ref: ref, open: hovered, showTooltipOnTop: showTooltipOnTop }, 
        // @ts-ignore
        React.createElement(Link, { to: `/cases/${id}` },
            React.createElement("div", { className: "case-id", style: { display: 'flex' } },
                React.createElement("div", { className: "case-hash" }, "#"),
                id))),
        hovered && !props.noTooltip && me && (React.createElement(Tooltip, { tooltipToLeft: props.tooltipToLeft, parentRef: ref, setShowTooltipOnTop: setShowTooltipOnTop, shouldShowOnTop: showTooltipOnTop, setIsMounted: setIsTooltipMounted }, singleCase ? (singleCase.deleted ? (React.createElement("div", { style: {
                display: 'block',
                margin: '80px auto',
                width: '60%',
            } },
            React.createElement("img", { style: {
                    width: '100%',
                }, src: deletedImage }),
            React.createElement("h1", null, lang.cases.caseHasBeenDeleted))) : (React.createElement(React.Fragment, null,
            React.createElement(CasePauseStatus, { case: singleCase }),
            React.createElement(Panel, null,
                React.createElement(CaseInfo, { caseId: singleCase.id })),
            React.createElement("br", null),
            React.createElement(CaseHistory, { caseId: `${singleCase.id}` })))) : (React.createElement(PlaceholderLoader, null))))));
};
export default CasePreview;
const CasePreviewStyled = styled.div `
  display: inline-block;
  background: #e6e6e6;
  padding: 0.2em 0.6em 0.2em 0.2em;
  border-radius: 1em;
  font-weight: 300;
  position: relative;

  ${(props) => props.open
    ? props.showTooltipOnTop
        ? `
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  `
        : `
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
`
    : ''} &:hover {
    opacity: 0.8;
  }

  div.case-hash {
    font-style: italic;
    display: inline-block;
    opacity: 0.7;
    font-weight: 900;
    margin-right: 0.3em;
    height: 1.3em;
    width: 1.3em;
    background-color: #bdbdbd;
    border-radius: 100%;
    padding: 0.05em 0.1em 0em 0em;
    text-align: center;
  }

  a {
    text-decoration: none;
    color: inherit;
  }
`;
//# sourceMappingURL=CasePreview.js.map